export default __webpack_public_path__ + "static/hep-liver-prevention-23760a429cb614e9937fed60b5d51025.jpg";